<ng-container *ngIf="data">
  <div class="label" *ngIf="data.key">{{ data.key }}</div>
  <div class="value" *ngIf="data.value||data.key" [innerHTML]="data.value || '-'"></div>
</ng-container>
